// import { useMemo } from "react";
import { CurrencyInputNumber } from "./CurrencyInputNumber";
import { Form, type FormItemProps, type InputNumberProps } from "antd";
import type { SpaceCompactProps } from "antd/es/space/Compact";

type CurrencyFormItemProps = Omit<FormItemProps, "children"> & {
    /** Props for the underlying CurrencyInputNumber */
    inputProps?: InputNumberProps<number>;
    /** wrapper props should have Space.Compact props but omitting children and className */
    wrapperProps?: Omit<SpaceCompactProps, "children">;
};

export const CurrencyFormItem: React.FC<CurrencyFormItemProps> = ({ inputProps, wrapperProps, ...itemProps }) => (
    <Form.Item name="amount" label="Amount" required {...itemProps}>
        <CurrencyInputNumber {...inputProps} wrapperProps={wrapperProps} />
    </Form.Item>
);
